import {all} from 'redux-saga/effects';

import {getImageSagaWatcher} from './get_image.saga'
import {getCommonImagesSagaWatcher} from './get_common_images.saga'
import {getImagesSagaWatcher} from './get_images.saga'
import {addImageSagaWatcher} from './add_image.saga'
import {updateImageSagaWatcher} from './update_image.saga'
import {deleteImageSagaWatcher} from './delete_image.saga'


export default function* imageSaga() {
    yield all([
        getImageSagaWatcher(),
        getCommonImagesSagaWatcher(),
        getImagesSagaWatcher(),
        addImageSagaWatcher(),
        updateImageSagaWatcher(),
        deleteImageSagaWatcher()
    ]);
}